import React, { useState } from "react";
import authBg from "../../images/authBg.jpg";
import fmeLogo from "../../images/fmeLogo.png";
import { Path } from "../../RoutesUtils";
import Swal from "sweetalert2";
import { PostService } from "../../services/genericPostService";
const Forget = () => {
  const [email, setEmail] = useState("");

  const onChange = (event) => {
    console.log("Event", event);
    setEmail(event.target.value);
  };

  const validation = () => {
    if (email.trim().length < 1) {
      modal("error", "Error", "Indtast venligst din e-mail");
      return false;
    }
    return true;
  };

  const modal = (icon, title, message) => {
    Swal.fire({
      icon: icon,
      title: title,
      text: message,
    });
  };

  const sendEmail = () => {
    const validate = validation();
    if (validate) {
      const data = {
        email: email,
      };
      const url = "/fmeApi/send_email.php";
      PostService(url, data, modal);
    }
  };

  return (
    <div className="2xl:h-[110vh] lg:h-[130vh] flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 lg:block hidden">
        <img
          src={authBg}
          alt="Decorative flower"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="w-full lg:w-1/2 p-8 lg:p-12 lg:p-16 flex flex-col justify-center items-center">
        <div className="w-full max-w-md">
          <div className="flex justify-center">
            <img src={fmeLogo} alt="Forglem mig ej logo" className="2xl:w-auto lg:w-44 w-auto" />
          </div>

          <h1 className="text-2xl lg:text-3xl text-center text-green 2xl:my-16 my-12">
            Glemt adgangskode
          </h1>

          <form>
            <div className="flex flex-col gap-8">
              <div className="w-full">
                <label htmlFor="email" className="block text-sm font-medium">
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="Enter your email"
                  onChange={onChange}
                  value={email}
                />
              </div>
            </div>

            <div className="flex justify-center md:mt-16 mt-10 mb-6">
              <button
                type="button"
                onClick={sendEmail}
                className="py-3 px-20 border border-transparent rounded-full text-sm font-medium text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
              >
                Indsend
              </button>
            </div>

            <p className="text-md md:mb-20 mb-10 text-center">
              Jeg kender min adgangskode,
              <a href={Path.login} className="ml-1 font-bold border-b">
                Log ind
              </a>
            </p>
            <p>
              Tjek venligst din e-mailindbakke, og du vil modtage en e-mail til
              nulstilling af din adgangskode. Ved at klikke på linket i e-mailen
              kan du nulstille din adgangskode og forsøge at logge ind igen.
            </p>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Forget;
